// serviceWorker.js

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 IPv4 localhost range
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Different origin, do not register service worker
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // On localhost, check service worker validity first
        checkValidServiceWorker(swUrl, config);

        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served by a service worker.'
          );

          // Immediately check for updates when tab loads
          navigator.serviceWorker.getRegistrations().then(registrations => {
            for (let registration of registrations) {
              console.log('Checking for service worker updates on tab load...');
              registration.update();
            }
          });

          // Periodic update check every 2 minutes
          setInterval(() => {
            navigator.serviceWorker.getRegistrations().then(registrations => {
              for (let registration of registrations) {
                console.log('Checking for service worker updates...');
                registration.update();
              }
            });
          }, 2 * 60 * 1000);
        });
      } else {
        // Not localhost - just register service worker directly
        registerValidSW(swUrl, config);

        navigator.serviceWorker.ready.then(() => {
          // Immediately check for updates when tab loads
          navigator.serviceWorker.getRegistrations().then(registrations => {
            for (let registration of registrations) {
              console.log('Checking for service worker updates on tab load...');
              registration.update();
            }
          });

          // Periodic update check every 2 minutes
          setInterval(() => {
            navigator.serviceWorker.getRegistrations().then(registrations => {
              for (let registration of registrations) {
                console.log('Checking for service worker updates...');
                registration.update();
              }
            });
          }, 2 * 60 * 1000);
        });
      }
    });
  }
}

// Helper function to check if we should show update popup
function shouldShowUpdatePopup(config) {
  // Check if we just reloaded - don't show popup if flag is set
  const justReloaded = sessionStorage.getItem('sw-reload-flag');
  if (justReloaded === 'true') {
    console.log('Skipping popup - just reloaded');
    return false;
  }
  return config && config.onUpdate;
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      // Delay update check slightly after reload to let state settle
      const justReloaded = sessionStorage.getItem('sw-reload-flag');
      const updateDelay = justReloaded === 'true' ? 1000 : 0;
      
      setTimeout(() => {
        // Immediately check for updates when a new tab opens
        registration.update();
        
        // Check if there's already a waiting service worker (detected by another tab)
        // Only show popup if waiting worker exists, is actually waiting, and we haven't just reloaded
        if (registration.waiting && registration.waiting.state === 'installed') {
          console.log('New service worker is waiting. Checking if should show update modal.');
          if (shouldShowUpdatePopup(config)) {
            config.onUpdate(registration);
          }
        }
      }, updateDelay);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content available, old content still served until tabs closed
              console.log(
                'New content is available and will be used when all tabs for this page are closed.'
              );

              // Only show popup if we haven't just reloaded
              if (shouldShowUpdatePopup(config)) {
                config.onUpdate(registration);
              }
            } else {
              // Content cached for offline use on first install
              console.log('Content is cached for offline use.');

              // Execute onSuccess callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If not, reload the page.
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then(response => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Unregister and reload.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found, proceed with registration
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error(error.message);
      });
  }
}
